import { AGENDA_CONTENT } from '@/utils/const/activity/lvs';
import styles from '../style.module.scss';
import { Element } from 'react-scroll';
import { LVSH1 } from '../../widget';
import { WebPNativeImage, WebPNextImage } from '@/components/WebPImage';
import FadeIn from '@/components/commonComponents/fadeIn';
import { useEffect, useState } from 'react';
import { getKconfContent } from '@/services/common-next';
import Link from 'next/link';
import { src } from '@/utils/common';
import { useUserAgentInfo } from '@/context/user-agent';

const Arrow = ({ style }: { style: React.CSSProperties }) => {
  return (
    <svg
      style={style}
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M11 0.5L15 5L11 9.5" stroke="#0C2D66" strokeLinejoin="round" />
      <line y1="5" x2="15" y2="5" stroke="#0C2D66" />
    </svg>
  );
};

const Agenda = (props: {
  content: typeof AGENDA_CONTENT.speech.content;
}): JSX.Element => {
  const { content } = props;
  const { isMobile } = useUserAgentInfo();
  return (
    <div className={styles['agenda-content']}>
      <div className={styles['left']}>
        {content.map((item) => (
          <div className={styles['timeline']} key={item.title}>
            <div className={styles['bullet']} />
            <div className={styles['content']}>
              <div className={styles['interval']}>{item.interval}</div>
              <div className={styles['title']}>{item.title}</div>
            </div>
          </div>
        ))}
      </div>
      <div className={styles['right']}>
        {content.map((item) => (
          <Link
            href={`/content/activity/lvs/${item.contentId}`}
            passHref
            key={item.title}
            legacyBehavior
          >
            <div className={styles['card']} key={item.title}>
              <div className={styles['background']} />
              <div className={styles['date']}>{item.interval}</div>
              <div className={styles['identity']}>
                <div className={styles['name']}>{item.speaker}</div>
                <div className={styles['desc']}>
                  {!isMobile
                    ? item.identity
                    : item.identity.split('、').join('\r\n')}
                </div>
              </div>
              <div className={styles['title']}>{item.title}</div>
              <div className={styles['direct']}>
                查看详情
                <Arrow style={{ marginLeft: 8 }} />
              </div>
              <WebPNativeImage
                src={src(item.portrait)}
                className={styles['portrait']}
              />
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
};

const Content = (props: typeof AGENDA_CONTENT) => {
  const { title, speech, agenda } = props;
  const [contents, setContents] = useState<(typeof AGENDA_CONTENT.speech)[]>([
    speech,
    agenda,
  ]);
  useEffect(() => {
    getKconfContent({
      key: 'website_lvs_config',
      name: 'platform_web',
      folder: 'streamlake',
    }).then((res) => {
      console.log([res.speech, res.agenda]);
      res && setContents([res.speech, res.agenda]);
    });
  }, []);
  return (
    <Element name={title.main} key={title.main}>
      <div className={styles['activity-wrapper']}>
        <LVSH1 title={title.main} subTitle={title.vice} />
        {contents.map((section) => (
          <FadeIn key={section.title}>
            <div className={styles['agenda-section']}>
              <div className={styles['agenda-title']}>{section.title}</div>
              <Agenda content={section.content} />
            </div>
          </FadeIn>
        ))}
      </div>
    </Element>
  );
};

export default Content;
